// @flow
import range from 'lodash/range'

// 0-24 months: each month
// 24-60 months: each half-year
// 60-144 months: each year
export const OPTIONS = range(0, 24).concat(range(24, 54, 6)).concat(range(60, 156, 12))

export function format(months: number) {
  if (months < 24) {
    return `${months} months`
  }

  const halfYears = Math.floor(months / 6)
  const years = Math.floor(months / 12)

  // include half-years when age is less than 5 years
  if (years < 5 && halfYears % 2 !== 0) {
    return `${years}.5 years`
  }

  return `${years} years`
}
